import { render, staticRenderFns } from "./RoleDataForm.vue?vue&type=template&id=e997e278"
import script from "./RoleDataForm.vue?vue&type=script&lang=js"
export * from "./RoleDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports